module.exports = __webpack_public_path__ + "static/media/icon-lush.5d571ce4.png";